import { render, staticRenderFns } from "./PortalSupportStep.vue?vue&type=template&id=5e29d1a6"
import script from "./PortalSupportStep.vue?vue&type=script&lang=js"
export * from "./PortalSupportStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports